import PropTypes from "prop-types";
import { isValidElement, useContext } from "react";
import TableContext from "./TableContext";
import Cell from "./Cell";
import Row from "./Row";

export default function Body({ children, className, id, style }) {
  const { table } = useContext(TableContext)

  const classNames = ["lds-table-body", className];
  let childrenToRender = null;

  if(children) {
    childrenToRender = children;
  } else {
    childrenToRender = (
      table.getRowModel().rows.map(row => (
        <RowFromConfig key={row.id} row={row} />
      ))
    )
  }

  return (
    <tbody
      className={classNames.join(" ")}
      id={id}
      data-testid={id}
      role="tablebody"
      style={style}
    >
      {childrenToRender}
    </tbody>
  )
}

function RowFromConfig({row}){
  return (
    <Row id={row.id}>
      {
        row.getVisibleCells().map(cell => {
          return <CellFromConfig key={cell.id} cell={cell} />
        })
      }
    </Row>
  )
}

function CellFromConfig({cell}) {
  const Component = cell.column.columnDef.cell;

  if(typeof Component === "string"){
    return <Cell id={cell.id}>{Component}</Cell>
  } else if (isValidElement(Component)) {
    return Component
  } else {
    return <Component key={cell.id} cellData={cell} />
  }
}

Body.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  id: PropTypes.string,
  style: PropTypes.object,
};
